import {type Environments} from "@common-core/web-component-runtime/runtime";

import type {Environment} from "./Environment";

// TODO(US2133070): temporarily hidden in all environments; restore
// "https://admin.qa.product-updates.dangerzone.coxautoservices.com/" (non-prod) and
// "https://admin.product-updates.coxautoservices.com/" (prod) once Product Updates is fixed.
const PRODUCT_UPDATES_URL_NON_PROD = "";
const PRODUCT_UPDATES_URL_PROD = "";

// TODO: add clients
export const environments: Environments<Environment> = {
  "dz/non-prod": (): Environment => {
    return {
      logoutUrl:
        "https://signin.dangerzone.coxautoservices.com/logout?bridge_env=QA&bridge_solution={solution}",
      bridgeBarApiUrl:
        "https://signin.dangerzone.coxautoservices.com/bridgebar",
      ldClientSideId: "5ea85d86bf32890a57ee69e3",
      landingPageUrl:
        "https://mycoxautomotive.dangerzone.coxautoservices.com/?partition=non-prod",
      productUpdatesUrl: PRODUCT_UPDATES_URL_NON_PROD
    };
  },
  "dz/prod": (): Environment => {
    return {
      logoutUrl:
        "https://signin.dangerzone.coxautoservices.com/logout?&bridge_solution={solution}",
      bridgeBarApiUrl:
        "https://signin.dangerzone.coxautoservices.com/bridgebar",
      ldClientSideId: "5ea85d86bf32890a57ee69e3",
      landingPageUrl: "https://mycoxautomotive.dangerzone.coxautoservices.com",
      productUpdatesUrl: PRODUCT_UPDATES_URL_PROD
    };
  },
  "live/non-prod": (): Environment => {
    return {
      logoutUrl:
        "https://signin.coxautoinc.com/logout?bridge_env=QA&bridge_solution={solution}",
      bridgeBarApiUrl: "https://signin.coxautoinc.com/bridgebar",
      ldClientSideId: "5ea85d86bf32890a57ee69e1",
      landingPageUrl:
        "https://mycoxautomotive.coxautoinc.com/?partition=non-prod",
      productUpdatesUrl: PRODUCT_UPDATES_URL_NON_PROD
    };
  },
  "live/prod": (): Environment => {
    return {
      logoutUrl:
        "https://signin.coxautoinc.com/logout?bridge_solution={solution}",
      bridgeBarApiUrl: "https://signin.coxautoinc.com/bridgebar",
      ldClientSideId: "5ea85d86bf32890a57ee69e1",
      landingPageUrl: "https://mycoxautomotive.coxautoinc.com",
      productUpdatesUrl: PRODUCT_UPDATES_URL_PROD
    };
  }
};
